import { createFileRoute, Link } from "@tanstack/react-router";
import { LoanCategoryPage } from "@/components/laneguide/LoanCategoryPage";
import { CAR_MODELS } from "@/lib/pseo-content";

export const Route = createFileRoute("/billan")({
  head: () => ({
    meta: [
      { title: "Billån – Jämför bilfinansiering från 20+ banker | Svensk Låneguide" },
      { name: "description", content: "Hitta billånet med lägst ränta. Vi jämför billån och bilfinansiering från 20+ svenska banker." },
      { property: "og:title", content: "Billån – Jämför bilfinansiering" },
      { property: "og:description", content: "Jämför billån från 20+ banker." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => (
    <LoanCategoryPage
      page="billan"
      productLabel="Billån"
      headingBefore="Finansiera bilen till"
      underlined="låg ränta"
      headingAfter=""
      subtitle={
        <>
          Dags att köpa ny bil? Här jämför vi och hittar marknadens bästa <Link to="/nyhet/$slug" params={{ slug: "billan-utan-kontantinsats" }} className="text-primary underline underline-offset-2">billån</Link> för 2026. Samtliga lån du hittar på sidan är utan säkerhet – det spelar alltså ingen roll om bilen är helt ny, köps av en bilhandlare eller om du hittat en på Blocket.
        </>
      }
      featuredTitleTemplate={(m) => `Toppval för billån i ${m}`}
      belowList={
        <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
          <h2 className="font-display text-2xl font-black text-foreground">Billån per bilmodell</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Se månadskostnad, ränta och långivare för den modell du är intresserad av.
          </p>
          <ul className="mt-5 flex flex-wrap gap-2">
            {CAR_MODELS.map((c) => (
              <li key={c.slug}>
                <Link
                  to="/billan/$model"
                  params={{ model: c.slug }}
                  className="inline-flex items-center rounded-md border border-border bg-card px-3 py-2 text-sm text-foreground no-underline transition hover:border-primary hover:text-primary"
                >
                  Billån {c.brand} {c.model}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      }
    />
  ),
});
